import React, { createContext, useContext } from "react";

const UserRolesContext = createContext([]);

export const UserRolesProvider = ({ roles = [], children }) => (
  <UserRolesContext.Provider value={roles}>
    {children}
  </UserRolesContext.Provider>
);

export const useUserRoles = () => useContext(UserRolesContext);